cv.PageView = Marionette.LayoutView.extend({
  template: cv.Templates['page/view'],

  regions : {
  },

  events: {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('PageView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  onAttach: function(){
  },

  onDestroy: function(){
  }
});
